import { NO_AMP, NO_APLICA } from '@atresmedia/datalayer/lib/utils/constants';
import {
  getDate,
  getTime,
  getMeta,
  getValueSession,
  removeValueSession
} from '@atresmedia/datalayer/lib/utils/functions';
import { getMetaContent, INFO_MODULO, AUTOR } from '../../../utils';

let infoModulo = getValueSession(INFO_MODULO);
if (infoModulo) {
  removeValueSession(INFO_MODULO);
}

const getReferrer = () => {
  const ref = sessionStorage.getItem('referrer');
  let finalUrl;
  if (!ref) {
    if (document.referrer) {
      finalUrl = document.referrer;
    }
  } else {
    finalUrl = ref;
  }
  sessionStorage.setItem('referrer', window.parent.location.href);
  return finalUrl;
};

export default () => {
  const { hostname } = document.location;
  const channel = hostname.split('.')[1] || NO_APLICA;
  const tipoContenido = getMeta('tipo-contenido');
  const timeModified = getMeta('article:modified_time');
  const timePublished = getMeta('article:published_time');
  const paginaSeriePrograma = getMeta('serie-programa');
  const vertical = getMeta('site-name');
  const tipoPagina = getMeta('tipo-pagina');
  const error = getMeta('error');
  const tipoConsumo = 'WEB';
  const consentAAM =
    localStorage.getItem('aamConsentValue') === 'true' ? '0' : '1';
  infoModulo = getValueSession(INFO_MODULO);

  return {
    tipoContenido,
    canal: channel,
    fechaPublicacion: getDate(timePublished),
    fechaActualizacion: getDate(timeModified),
    horaPublicacion: getTime(timePublished),
    horaActualizacion: getTime(timeModified),
    paginaSeriePrograma,
    tipoConsumo,
    error404: error === 'true' ? '404' : undefined,
    amp: NO_AMP,
    consentAAM,
    vertical,
    tipoPagina,
    infoModulo,
    referente: getReferrer(),
    autor: getMetaContent(AUTOR)
  };
};
